import React from 'react';
import {DocTable as BasicDocTable, DocTableProps} from './DocTable';
import {DocTableAsRows} from './DocTableAsRows';
import {useIsDesktop} from '../../hooks';

export const DocTable: React.FC<DocTableProps> = props => {
    let isDesktop = true;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isDesktop = useIsDesktop();
    }catch (e) {
        console.error(e)
    }

    return isDesktop
            ? <BasicDocTable {...props} />
            : <DocTableAsRows {...props} />;
};
